var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-full-width-panel"},[(_vm.singularityFullWidthPanel === 'settings')?_c('Settings'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }